import React from "react";

export default function Footer() {
  return (
    <footer className="rf-footer" data-testid="site-footer">
      <div className="rf-wrap">
        <div className="rf-footer__row">
          <span className="rf-footer__copy">&copy; 2026 Renaflex</span>
          <a href="#terms" className="rf-footer__link rf-footer__link--terms">
            Terms &amp; Conditions
          </a>
          <a href="#privacy" className="rf-footer__link rf-footer__link--privacy">
            Privacy Policy
          </a>
          <span className="rf-footer__by">
            Website by <span className="rf-footer__brand">Madarth</span>
            <sup>&reg;</sup>
          </span>
        </div>
      </div>
    </footer>
  );
}
